module.exports = __webpack_public_path__ + "static/media/kml.fe0572f5.svg";